import actions from "./actions";

const initialState = {
    paidPlansAnnualDiscountPercent: "",
    freePlans: [],
    paidPlans: []
};

export default function plansReducer(prevState = initialState, action) {
    switch(action.type) {
        case actions.SET_STATE:
            return {...prevState, ...action.payload};
        default: 
            return prevState;
    }
}
